function setupReadMore() {
    const descriptionElement = document.querySelector('.product__description');
    const readMoreButton = document.querySelector('.read-more-button');
    const maxHeight = 200;

    const actualHeight = descriptionElement.scrollHeight;

    if (descriptionElement) {

        if (window.innerWidth <= 749 && actualHeight > maxHeight) {
            if (readMoreButton) {
                readMoreButton.style.display = 'block';
                readMoreButton.addEventListener('click', toggleReadMore);
            }
            descriptionElement.classList.add('fade-effect');
        } else {
            if (readMoreButton) {
                readMoreButton.style.display = 'none';
            }
            descriptionElement.classList.remove('fade-effect');
            descriptionElement.style.maxHeight = '';
            descriptionElement.classList.remove('expanded');
        }
    }

    function toggleReadMore() {
        if (descriptionElement.classList.contains('expanded')) {
            descriptionElement.classList.remove('expanded');
            descriptionElement.classList.add('fade-effect');
            readMoreButton.innerText = 'Continue Reading...';
            descriptionElement.style.maxHeight = maxHeight + 'px';
        } else {
            descriptionElement.classList.add('expanded');
            descriptionElement.classList.remove('fade-effect');
            readMoreButton.innerText = 'Show Less';
            descriptionElement.style.maxHeight = actualHeight + 'px';
        }
    }
}

setupReadMore();

